import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=8b9329b2&lang=html&"
import script from "./MenuIcon.vue?vue&type=script&lang=js&"
export * from "./MenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports